/** Campo de tempo da etapa no formato do legado HH,MM (1,30 = 1h30): só dígitos, uma vírgula,
 *  até 2 casas e minutos de 00 a 59 (QA 15/10/2026). Devolve o texto aceito. */
export function mascaraTempoHM(v: string, anterior: string): string {
  const s = v.replace(/\./g, ",").replace(/[^0-9,]/g, "");
  const [h, ...resto] = s.split(",");
  if (!resto.length) return (h ?? "").slice(0, 4);
  const m = resto.join("").slice(0, 2);
  if (m.length >= 1 && Number(m[0]) > 5) return anterior; // dezena dos minutos só 0–5
  return `${(h ?? "").slice(0, 4)},${m}`;
}
